import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { LegalPage } from "@/features/onboarding/pages/legal-page";

export const Route = createFileRoute("/onboarding/_guarded/legal")({
	head: () => pageTitle("Legal"),
	component: LegalPage,
});
